import clsx from 'clsx';
import React from 'react';
import { toggleSwitch } from '../../reducers/switch';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import ToggleIcon from '../../assets/icons/sidebar-toggle-icon.svg?react';
import ChevronIcon from '../../assets/icons/chevron-down-icon.svg?react';
import { useDispatch } from 'react-redux';
import { InvestigationQuestionWithCategory } from '@EHSNavigator/backend';
import InvestigationDynamicQuestion from '../../components/InvestigationDynamicQuestion';
import Button from '../../components/Button';

interface InvestigationReportingStepThreeProps {
  otherClasses?: string;
  formHandler: any;
  handleNextStep: (steps: number) => void;
  questions: InvestigationQuestionWithCategory[];
}

const InvestigationReportingStepThree: React.FC<
  InvestigationReportingStepThreeProps
> = ({ otherClasses, formHandler, handleNextStep, questions }) => {
  const investigationReportingStepThreeClasses = clsx(otherClasses);
  const sm = useButtonSizeSmall();
  const dispatch = useDispatch();
  let questionCounter = 0;

  return (
    <div
      className={investigationReportingStepThreeClasses}
      data-testid="investigation-reporting-step-three"
    >
      <div className="flex flex-row items-start gap-2.5">
        <button
          type="button"
          className="bg-translucent-background/80 border-neutral-tones-text/30 rounded-5 w-fit cursor-pointer border p-0.5 lg:hidden"
          onClick={() => dispatch(toggleSwitch())}
        >
          <ToggleIcon />
        </button>
        <div className="flex flex-col gap-1">
          <span className="text-brand-byzantine font-inter-variable text-xs leading-4 font-bold lg:hidden">
            INJURY/ILLNESS
          </span>
          <h4 className="text-neutral-tones-text font-inter-variable font-bold">
            Let’s Get to the Root Cause
          </h4>
          <p className="text-brand-byzantine font-inter-variable text-base leading-5 font-bold lg:mt-15">
            STEP 3 / 5
          </p>
        </div>
      </div>
      <p className="font-inter-variable text-neutral-tones-text mt-8 text-sm leading-4 font-medium lg:mt-9 lg:text-xl lg:leading-6">
        We kindly request that you respond to the following inquiries with the
        utmost accuracy and detail, as your insights are crucial for our ongoing
        injury investigation process.
      </p>

      <div className="mt-9 flex flex-col gap-9">
        {questions?.map(({ category, questions }, index) => (
          <div
            key={index}
            className="rounded-10 bg-card-backgrounds/5 border-neutral-tones-text/10 border px-5 pt-5 pb-8"
          >
            <h6 className="text-brand-papery font-inter-variable text-base leading-5 font-bold uppercase lg:text-xl lg:leading-6">
              {category}
            </h6>
            <div
              className={clsx(
                'mt-2.5 grid gap-9',
                questions?.length === 2
                  ? 'grid-cols-1 md:grid-cols-2'
                  : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3',
              )}
            >
              {questions?.map((question, innerIndex) => {
                const currentIndex = questionCounter++;
                return (
                  <>
                    <InvestigationDynamicQuestion
                      key={innerIndex}
                      question={question}
                      index={currentIndex}
                      formHandler={formHandler}
                    />
                  </>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-9 flex items-center gap-8">
        <Button
          size={sm}
          otherClasses="w-full sm:w-185"
          variant="secondary"
          type="button"
          onClick={() => handleNextStep(2)}
        >
          <ChevronIcon className="h-6 w-6 rotate-90 [&>path]:fill-current" />
          Go Back
        </Button>
        <Button
          size={sm}
          otherClasses="w-full sm:w-185"
          type="button"
          onClick={() => handleNextStep(4)}
        >
          Next
          <ChevronIcon className="h-6 w-6 -rotate-90 [&>path]:fill-current" />
        </Button>
      </div>
    </div>
  );
};

export default InvestigationReportingStepThree;
